import React, { useEffect } from "react";
import ResourseButtons from "../../../components/form/buttons/ResourseButtons";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import TextAreaField from "../../../components/form/TextAreaField";
import SingleFileUpload from "../../../components/form/SingleFileUpload";
import { addCommunityProposalApprove } from "../../../features/projectsSlice";
import { useNavigate } from "react-router-dom";
import InputField from "../../../components/form/InputField";
import { closeModal } from "../../../features/modalSLice";
import { useNotification } from "../../../components/notification/NotificationContainer";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  addCommunityApproveSchema,
  addCommunityProposalApproveSchema,
} from "../../../schemas";
import { getCommunityUsers, unsetUsers } from "../../../features/usersSlice";
import SelectField from "../../../components/form/SelectField";

const AddCommunityPlanningApproval = ({ id, community_id, name }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const addNotification = useNotification();
  const users = useSelector((state) => state.users.data);
  const loading = useSelector(
    (state) => state.projects.load.addCommunityProposalApprove
  );

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: zodResolver(addCommunityProposalApproveSchema) });

  const onSubmit = async (data) => {
    try {
      const res = await dispatch(addCommunityProposalApprove(data));
      if (addCommunityProposalApprove.fulfilled.match(res)) {
        dispatch(closeModal());
        addNotification("Proposal approved successfully!", "success");
        navigate("/requests/community-approvals");
      } else {
        addNotification(res.payload.message, "error");
        if (res.payload.code === 412) {
          dispatch(closeModal());
          navigate("/requests/community-approvals");
        }
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  useEffect(() => {
    dispatch(getCommunityUsers(community_id));

    return () => {
      dispatch(unsetUsers());
    };
  }, []);

  useEffect(() => {}, [users]);

  return (
    <>
      {id && (
        <div className="min-w-80 sm:min-w-96 max-w-2xl w-full text-text-1/80">
          <div className="flex flex-col justify-center items-center gap-2 py-5 border-b border-bkg2 mb-4 ">
            <h4>Approve Proposal</h4>
          </div>
          <p className="font-extrabold ">{name}</p>
          <form
            onSubmit={handleSubmit(onSubmit)}
            method="post"
            encType="multipart/form-data"
          >
            <SelectField
              register={register}
              data={[{ id: "", name: "-- Select User" }, ...users]}
              name="assigned_to"
              label="Assignee"
              errors={errors.assigned_to}
            />
            <TextAreaField
              register={register}
              label="Comment"
              name="comment"
              errors={errors.comment}
            />
            <SingleFileUpload
              register={register}
              setValue={setValue}
              label="Council Minutes"
              name="community_council_minute"
              errors={errors.community_council_minute}
              accept="application/pdf"
            />
            <InputField
              register={register}
              name="id"
              defaultValue={id}
              type="hidden"
            />
            <ResourseButtons loading={loading} />
          </form>
        </div>
      )}
    </>
  );
};

export default AddCommunityPlanningApproval;
